
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

import dayjs from 'dayjs'
import SearchInputField from '~/components/Common/UI/Search/SearchInputField'

export default {
    name: 'SearchSelect',
    components: {
        SearchInputField
    },
    props: {
        optionList: Array,
    },
    data() {
        return {
            selected: '날짜',
            inputText: '',
            date: '',
        }
    },
    watch: {
        date() {
            if (this.date !== '' && this.date != null) {
                this.sendData()
            }
        },
        selected() {
            this.inputText = ''
            this.date = ''
            this.$emit('changeType', this.selected)
        },
        inputText() {
            this.sendData()
        },
    },
    beforeDestroy() {
        this.CLEAR_STORE()
    },
    methods: {
        ...mapActions('search', ['GET_SEARCH_INFO']),
        ...mapMutations('search', ['CLEAR_STORE']),      
        ...mapActions('modal', ['SHOW_ALERT', 'HIDE_MODAL']),
        // 입력받은 값으로 검색
        sendData() {
            // 22.02.24 한수예
            const today = new Date();
            const year = today.getFullYear();
            const month = ('0' + (today.getMonth() + 1)).slice(-2);
            const day = ('0' + today.getDate()).slice(-2);
            const dateString = year + month + day;    
            
            // 현재 날짜와 비교
            if(this.date != null && this.date !== '' && this.date !== undefined && dateString < dayjs(this.date).format('YYYYMMDD')){
                 this.SHOW_ALERT({
                    content: '선택일자가 현재일자보다 클 수 없습니다.',
                })
                this.date = ''
            } else {
                this.GET_SEARCH_INFO({
                code: this.inputText,
                startDate: dayjs(this.date).format('YYYYMMDD'),
            })
            }
            // this.GET_SEARCH_INFO({
            //     code: this.inputText,
            //     startDate: dayjs(this.date).format('YYYYMMDD'),
            // })
        },
        getCode(code) {
            this.inputText = code
        },
    },
}
